import first from 'lodash/first'
import React, { FC, useMemo } from 'react'

import { LeadMagnet } from '@Components/CMS/LeadMagnet'
import { Block, ImageResource } from '@Generated/graphql'
import { getJSONFieldValue, getReferenceFieldValue } from '@Globals/CMS/FieldHelpers'

interface LeadMagnetBlockData {
  bottomButtonText: string
  buttonText: string
  desktopImage: string
  identifyingLabel: string
  mobileImage: string
  successMessage: string
  text: string
  title: string
}

const getBlockData = (leadMagnetBlock: Block): LeadMagnetBlockData => {
  const image = first(getReferenceFieldValue<ImageResource>(leadMagnetBlock.fields || [], 'image'))

  return {
    bottomButtonText: getJSONFieldValue(leadMagnetBlock.fields || [], 'bottomButtonText') || '',
    buttonText: getJSONFieldValue(leadMagnetBlock.fields || [], 'buttonText') || '',
    desktopImage: image?.url || '',
    identifyingLabel: getJSONFieldValue(leadMagnetBlock.fields || [], 'identifyingLabel') || '',
    mobileImage: image?.mobileURL || '',
    successMessage: getJSONFieldValue(leadMagnetBlock.fields || [], 'successMessageText') || '',
    text: getJSONFieldValue(leadMagnetBlock.fields || [], 'text') || '',
    title: getJSONFieldValue(leadMagnetBlock.fields || [], 'mainTitle') || '',
  }
}

interface LeadMagnetBlockProps {
  leadMagnetBlock: Block
}

const LeadMagnetBlock: FC<LeadMagnetBlockProps> = ({ leadMagnetBlock }) => {
  const {
    bottomButtonText,
    buttonText,
    desktopImage,
    identifyingLabel,
    mobileImage,
    successMessage,
    text,
    title,
  } = useMemo(() => getBlockData(leadMagnetBlock), [leadMagnetBlock])

  return (
    <LeadMagnet
      bottomButtonText={bottomButtonText}
      buttonText={buttonText}
      desktopImage={desktopImage}
      identifyingLabel={identifyingLabel}
      mobileImage={mobileImage}
      successMsg={successMessage}
      text={text}
      title={title}
    />
  )
}

export default LeadMagnetBlock
